import React, { useCallback, useEffect, useState } from "react";
import {getData, postData, postFormData} from '../middleware/apiMiddleware';
import s from './customer.module.css';
import { useNavigate, useParams } from "react-router-dom";
import {RedButton, GreenButton, BlueButton} from '../components/MyButton';
import {modifiedDate} from '../middleware/dateControl';
import MyComponentLoading from '../components/Utilities/MyComponentLoading';
import CustomerBasic from '../components/CustomerBasic';
import CustomerDollar from '../components/CustomerDollar';

import MyTooltip from '../components/Utilities/MyTooltip';

export default function Customer() {	
	const navigate = useNavigate();
	
	let params = useParams();
  let userId = params.userId;
	
	const [fetchCompleted, setFetchCompleted] = useState(false);
	const [username, setUsername] = useState(null);
	const [phone, setPhone] = useState(null);
	
	const fetchData = async () => {
		getData('customerApi/getById?userId=' + userId, navigate)
		.then(res => {
				
				let d = res.data;
				setUsername(d.username);
				setPhone(d.phone);
			
				setFetchCompleted(true);
			}
		);
		
		
		
	}
	useEffect(() => {
		fetchData();
	}, []);
	
	if (!fetchCompleted) {
		return (<MyComponentLoading />)
	}
	
	return (<div className={s.mainHolder}>
	
	
		<div>
			<div style={{display:"flex", gap:"10px", justifyContent:"center", alignItems:"center"}}>
				<MyTooltip msg={"&lt;page&gt;" +
												"customer.js<br/><br/>" +
												"&lt;components&gt;<br/>" +
												"CustomerBasic.js<br/>" + 
												"CustomerDollar.js<br/>"} /> 
				<div style={{fontSize:"32px", fontWeight:"bold"}}>{username}</div>
			</div>
			<div style={{display:"flex", gap:"10px", justifyContent:"center", alignItems:"center"}}>
				<div>(id:{userId})</div>
				<div>Tel: {phone}</div>
			</div>
		</div>
		<CustomerBasic userId={userId} />
		<CustomerDollar userId={userId} />
	</div>);
	
}

